import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./../Styles/about.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Login from "./Login";

import Profile from "./Profie";
import HorizontalAds from "../../Admin/Pages/HorizontalAds";
function DynamicImage({ name, defaultImage, alt, className, ...props }) {
  const extensions = ["jpg", "jpeg", "png", "webp", "gif", "svg", "avif"];
  const [index, setIndex] = useState(0);

  const src =
    index < extensions.length
      ? `/images/about/${name}.${extensions[index]}`
      : defaultImage;

  const handleError = () => {
    if (index < extensions.length - 1) {
      setIndex((prev) => prev + 1);
    }
  };

  return (
    <img
      {...props}
      src={src}
      alt={alt || name}
      className={className}
      onError={handleError}
    />
  );
}
export default function About() {
  useEffect(() => {
    AOS.init({
      duration: 900,
      once: true,
      easing: "ease-in-out",
    });
  }, []);
  const [showLogin, setShowLogin] = useState(false);

  const [showProfile, setShowProfile] = useState(false);

  const navigate = useNavigate();

  // const handleListing = (path, serviceName) => {
  //   const loginUser = JSON.parse(sessionStorage.getItem("user"));

  //   // Not logged in
  //   if (!loginUser) {
  //     navigate("/register", {
  //       state: {
  //         redirectTo: path,
  //         service: serviceName,
  //       },
  //     });
  //     return;
  //   }

  //   // Admin can access everything
  //   if (loginUser.role === "admin") {
  //     navigate(path);
  //     return;
  //   }

  //   // Get provider options
  //   let providerOptions = loginUser.provider_options || [];

  //   // Handle if backend sends string instead of array
  //   if (typeof providerOptions === "string") {
  //     try {
  //       providerOptions = JSON.parse(providerOptions);
  //     } catch {
  //       providerOptions = providerOptions
  //         .split(",")
  //         .map((item) => item.trim().toLowerCase());
  //     }
  //   }

  //   providerOptions = providerOptions.map((item) => String(item).toLowerCase());

  //   // Allow access if service exists
  //   if (providerOptions.includes(serviceName.toLowerCase())) {
  //     navigate(path);
  //     return;
  //   }
  // };
  const handleListing = (path, serviceName) => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));

    // Not logged in
    if (!loginUser) {
      navigate("/register", {
        state: {
          redirectTo: path,
          service: serviceName,
        },
      });
      return;
    }

    // Admin can access everything
    if (loginUser.role === "admin") {
      navigate(path);
      return;
    }

    // Get provider options
    let providerOptions = loginUser.provider_options || [];

    // Handle if backend sends string instead of array
    if (typeof providerOptions === "string") {
      try {
        providerOptions = JSON.parse(providerOptions);
      } catch {
        providerOptions = providerOptions
          .split(",")
          .map((item) => item.trim().toLowerCase());
      }
    }

    // Make sure it is an array
    if (!Array.isArray(providerOptions)) {
      providerOptions = [];
    }

    providerOptions = providerOptions.map((item) => String(item).toLowerCase());

    // User has the required provider option
    if (providerOptions.includes(serviceName.toLowerCase())) {
      navigate(path);
      return;
    }

    // User is logged in but does not have this provider option
    setShowProfile(true);
  };
  return (
    <div className="eb-about-page">
      {/* Hero Section */}
      <section className="eb-about-hero">
        <div className="container text-center">
          <h1 className="eb-hero-title" data-aos="fade-down">
            About Embroidery Bazar
          </h1>
          <p
            className="eb-hero-subtitle"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            India's trusted marketplace for embroidery machines, workspace,
            designers, and embroidery services.
          </p>
        </div>
      </section>

      <div className="container">
        <section className="eb-zigzag-section">
          <div className="row align-items-center g-5">
            <div className="col-lg-6  p-4" data-aos="fade-right">
              <div className="eb-img-wrapper">
                <DynamicImage
                  name="design"
                  alt="Embroidery Design"
                  className="eb-zigzag-img"
                />
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-left">
              <span className="eb-about-tag">Design Marketplace</span>
              <h2 className="eb-zigzag-heading">
                Buy or Sell Embroidery Designs
              </h2>
              <ul className="eb-feature-list">
                <li>
                  <span className="eb-check-icon">✔</span> Buy premium
                  embroidery designs
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> Sell Your Own Designs
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> Multiple design
                  categories
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> Easy Search &
                  Categories
                </li>
              </ul>
              <div className="eb-action-btns">
                <button
                  className="eb-light-btn primary"
                  // onClick={() => handleListing("/user/add-design")}
                  onClick={() => handleListing("/user/designs", "designs")}
                >
                  <i className="bi bi-palette-fill me-2"></i>
                  Sell Design
                </button>

                <button
                  className="eb-light-btn secondary"
                  onClick={() => navigate("/designs")}
                >
                  <i className="bi bi-search me-2"></i>
                  Buy Design
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="eb-zigzag-section">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 order-lg-2 p-4" data-aos="fade-left">
              <div className="eb-img-wrapper">
                <DynamicImage
                  name="designer"
                  alt="Designer"
                  className="eb-zigzag-img"
                />
              </div>
            </div>
            <div className="col-lg-6 order-lg-1" data-aos="fade-right">
              <span className="eb-about-tag">Designers</span>
              <h2 className="eb-zigzag-heading">
                Create Profile or Hire Embroidery Designers and Sketchers
              </h2>
              <ul className="eb-feature-list">
                <li>
                  <span className="eb-check-icon">✔</span> Hire experienced
                  designers and Sketchers
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> Create your Designer
                  and Sketchers Profile
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> Showcase your
                  experience
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> Connect directly with
                  Designers and Sketchers
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> Build your
                  professional network
                </li>
              </ul>
              <div className="eb-action-btns">
                <button
                  className="eb-light-btn primary"
                  // onClick={() => handleListing("/user/add-designer")}
                  onClick={() =>
                    handleListing("/user/add-designer", "designers")
                  }
                >
                  <i className="bi bi-person-badge-fill me-2"></i>
                  Create Profile
                </button>

                <button
                  className="eb-light-btn secondary"
                  onClick={() => navigate("/designer")}
                >
                  <i className="bi bi-person-check-fill me-2"></i>
                  Hire Designer
                </button>
              </div>
            </div>
          </div>
        </section>
        <section className="eb-zigzag-section">
          <div className="row align-items-center g-5">
            {/* IMAGE */}
            <div className="col-lg-6 p-4" data-aos="fade-right">
              <div className="eb-img-wrapper">
                <DynamicImage
                  name="bidwork"
                  alt="Embroidery Work Bids"
                  className="eb-zigzag-img"
                />
              </div>
            </div>

            {/* CONTENT */}
            <div className="col-lg-6" data-aos="fade-left">
              <span className="eb-about-tag">Work Bids</span>

              <h2 className="eb-zigzag-heading">
                Post Your Embroidery Work & Hire Designers
              </h2>

              <ul className="eb-feature-list">
                <li>
                  <span className="eb-check-icon">✔</span>
                  Post your embroidery design work
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Receive bids from experienced designers
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Compare designers and their bids
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Select the best designer for your work
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Start and manage your work easily
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Track work progress and delivery
                </li>
              </ul>

              <div className="eb-action-btns">
                {/* POST WORK */}
                <button
                  className="eb-light-btn primary"
                  onClick={() => handleListing("/user/add-work", "job_worker")}
                >
                  <i className="bi bi-plus-circle-fill me-2"></i>
                  Post Your Work
                </button>

                {/* FIND WORK */}
                <button
                  className="eb-light-btn secondary"
                  onClick={() => navigate("/work-list")}
                >
                  <i className="bi bi-briefcase-fill me-2"></i>
                  Find Work
                </button>
              </div>
            </div>
          </div>
        </section>
        {/* Feature: Work Bids */}

        {/* Feature 1: Machines */}
        <section className="eb-zigzag-section">
          <div className="row align-items-center g-5">
            <div className="col-lg-6" data-aos="fade-left">
              <span className="eb-about-tag">Machine Marketplace</span>
              <h2 className="eb-zigzag-heading">
                Buy or Sell Old Embroidery Machines
              </h2>
              <ul className="eb-feature-list">
                <li>
                  <span className="eb-check-icon">✔</span> Buy used embroidery
                  machines
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> Sell your old machine
                  easily
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> Verified machine
                  listings
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> Direct contact with
                  sellers
                </li>
              </ul>
              <div className="eb-action-btns">
                <button
                  className="eb-light-btn primary"
                  // onClick={() => handleListing("/user/add-machine")}
                  onClick={() => handleListing("/user/add-machine", "machines")}
                >
                  <i className="bi bi-gear-fill me-2"></i>
                  Sell Machine
                </button>

                <button
                  className="eb-light-btn secondary"
                  onClick={() => navigate("/machine")}
                >
                  <i className="bi bi-cart-check-fill me-2"></i>
                  Buy Machine
                </button>
              </div>
            </div>
            <div className="col-lg-6 p-4" data-aos="fade-right">
              <div className="eb-img-wrapper">
                <DynamicImage
                  name="machine"
                  alt="Embroidery Machine"
                  className="eb-zigzag-img"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Feature 2: Workspace */}
        <section className="eb-zigzag-section">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 order-lg-1 p-4" data-aos="fade-left">
              <div className="eb-img-wrapper">
                <DynamicImage
                  name="workspace"
                  defaultImage="/images/suppliers.jpg"
                  alt="Workspace"
                  className="eb-zigzag-img"
                />
              </div>
            </div>
            <div className="col-lg-6 order-lg-2" data-aos="fade-right">
              <span className="eb-about-tag">Workspace</span>
              <h2 className="eb-zigzag-heading">
                Take or Provide Machine Workspace On Rent
              </h2>
              <ul className="eb-feature-list">
                <li>
                  <span className="eb-check-icon">✔</span> Rent ready-to-use
                  workspaces
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> List your available
                  workspace
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> Search by city and
                  location
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> Direct owner contact
                </li>
              </ul>

              <div className="eb-action-btns">
                <button
                  className="eb-light-btn primary"
                  // onClick={() => handleListing("/user/add-workspace")}
                  onClick={() =>
                    handleListing("/user/add-workspace", "workspaces")
                  }
                >
                  <i className="bi bi-building-add me-2"></i>
                  Provide Workspace
                </button>

                <button
                  className="eb-light-btn secondary"
                  onClick={() => navigate("/house")}
                >
                  <i className="bi bi-search me-2"></i>
                  Find Workspace
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Feature 5: Suppliers */}
        <section className="eb-zigzag-section">
          <div className="row align-items-center g-5">
            <div className="col-lg-6" data-aos="fade-right">
              <span className="eb-about-tag">Suppliers</span>
              <h2 className="eb-zigzag-heading">
                Find Or Become Embroidery Material Suppliers
              </h2>
              <ul className="eb-feature-list">
                <li>
                  <span className="eb-check-icon">✔</span> Find thread suppliers
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> Find beads suppliers
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> Find spare parts
                  suppliers
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> Promote your supplier
                  business
                </li>
                <li>
                  <span className="eb-check-icon">✔</span> Increase business
                  visibility
                </li>
              </ul>
              <div className="eb-action-btns">
                <button
                  className="eb-light-btn primary"
                  // onClick={() => handleListing("/user/add-supplier")}
                  onClick={() =>
                    handleListing("/user/add-supplier", "supplier")
                  }
                >
                  <i className="bi bi-boxes me-2"></i>
                  Become Supplier
                </button>

                <button
                  className="eb-light-btn secondary"
                  onClick={() => navigate("/beads-supplier")}
                >
                  <i className="bi bi-truck me-2"></i>
                  Find Suppliers
                </button>
              </div>
            </div>
            <div className="col-lg-6 p-4" data-aos="fade-left">
              <div className="eb-img-wrapper">
                <DynamicImage
                  name="suppliers"
                  defaultImage="/images/suppliers.jpg"
                  alt="Suppliers"
                  className="eb-zigzag-img"
                />
              </div>
            </div>
          </div>
        </section>
        {/* Feature: Designer Requirements */}
        <section className="eb-zigzag-section">
          <div className="row align-items-center g-5">
            {/* CONTENT */}
            <div className="col-lg-6 order-lg-2" data-aos="fade-left">
              <span className="eb-about-tag">Designer Requirements</span>

              <h2 className="eb-zigzag-heading">
                Find the Right Embroidery Designer for Your Requirement
              </h2>

              <ul className="eb-feature-list">
                <li>
                  <span className="eb-check-icon">✔</span>
                  Post your designer requirement
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Mention required skills and experience
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Specify your work type and requirements
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Receive responses from interested designers
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Compare designer profiles and experience
                </li>

                <li>
                  <span className="eb-check-icon">✔</span>
                  Connect with the right designer
                </li>
              </ul>

              <div className="eb-action-btns">
                {/* OWNER POSTS REQUIREMENT */}
                <button
                  className="eb-light-btn primary"
                  onClick={() =>
                    handleListing("/user/add-hiring", "job_worker")
                  }
                >
                  <i className="bi bi-person-plus-fill me-2"></i>
                  Post Requirement
                </button>

                {/* DESIGNER FINDS REQUIREMENTS */}
                <button
                  className="eb-light-btn secondary"
                  onClick={() => navigate("/hiring")}
                >
                  <i className="bi bi-search me-2"></i>
                  Find Requirements
                </button>
              </div>
            </div>

            {/* IMAGE */}
            <div className="col-lg-6 order-lg-1 p-4" data-aos="fade-right">
              <div className="eb-img-wrapper">
                <DynamicImage
                  name="hiring"
                  alt="Designer Requirement"
                  className="eb-zigzag-img"
                />
              </div>
            </div>
          </div>
        </section>

        <HorizontalAds />
        <Login
          isOpen={showLogin}
          onClose={() => setShowLogin(false)}
          openRegister={() => {
            setShowLogin(false);
          }}
        />

        {showProfile && (
          <Profile isOpen={showProfile} onClose={() => setShowProfile(false)} />
        )}
      </div>
    </div>
  );
}
